export default __webpack_public_path__ + "static/media/references__harfa.a02d55f0.jpg";